import React from 'react'

import ListItem from './ListItem'

import styles from './Admin.module.css'

const ListTable = ({ title, columns, routeName, items }) => {
  return (
    <>
      {title && <h2>{title}</h2>}
      <table className={styles.list}>
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items &&
            items.map((item, i) => (
              <ListItem
                item={item}
                columns={columns}
                routeName={routeName}
                key={i}
              />
            ))}
        </tbody>
      </table>
    </>
  )
}

export default ListTable
